import React from 'react'
import { useHistory } from 'react-router-dom';
import { EndCallIcon } from '../../../assets/Logos/Icons';

function ConformEndModal({ state, setState, onEnd, onCancel }) {

    const history = useHistory();

    let handleClose = () => {


    }

    let handleEnd = () => {

    }




    return (
        <>
            {
                state ?

                    <div className="c-modal-loader" >
                        <div className="c-modal-body" style={{padding:"15px", height:"268px"}}>
                            <div className="c-modal-content" style={{marginBottom:"0px"}}>

                                <div className="c-modal-end-icon">
                                <EndCallIcon />
                                </div>

                                {
                                    "Are you sure want to end \n this appointment?".split('\n')
                                        .map(e => <div>{e}</div>)
                                }
                            </div>

                            <div className="c-modal-buttons">
                                <button className='c-modal-close-button' onClick={onCancel}>Take me back</button>
                                <button className='c-modal-end-button' onClick={onEnd}>End Appointment</button>

                            </div>
                        </div>
                    </div> : null
            }
        </>
    )
}

export default ConformEndModal